// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__cHV6m","rootCenter":"LoadMoreObserver_rootCenter__jftqA","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2O4_R"};